module.exports = __webpack_public_path__ + "static/media/cc_icon-pulse.bb9c7810.svg";